<template lang="html">
  <b-container>
    <FrontHero
      v-if="$route.meta.showHeaderOnFirstPage && !('page' in $route.query)"
    />
    <NavPaginatedSongList />
  </b-container>
</template>

<script>
import NavPaginatedSongList from "@/components/NavPaginatedSongList";
import FrontHero from "@/components/FrontHero";
import store from "@/store/index";
export default {
  name: "SongQuery",
  components: {
    FrontHero,
    NavPaginatedSongList
  },
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    //console.log("beforeRouteEnter", to, from, next);
    console.log(to.query);
    var page = 1;
    if ("page" in to.query) {
      page = to.query.page;
    }
    var obj = {
      content: to.meta.content,
      page: page,
      onlyFavoriteIds: to.meta.onlyFavoriteIds,
      onlyKnownChords: to.meta.onlyKnownChords
    };
    if ("search" in to.query) {
      obj.searchQuery = to.query.search;
    }
    if ("tuning" in to.params) {
      var currentTuning = store.getters.ukeTuning;
      var validTunings = ["C", "G"];
      if (
        validTunings.includes(to.params.tuning) &&
        currentTuning != to.params.tuning
      ) {
        store.dispatch("setTuning", to.params.tuning);
      }
    }
    next(() => {
      store.dispatch("updateSongQueryAndLoad", obj);
    });
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate(to, from, next) {
    //console.log("beforeRouteUpdate", to, from, next);
    console.log(to.query);
    var page = 1;
    if ("page" in to.query) {
      page = to.query.page;
    }
    var obj = {
      content: to.meta.content,
      page: page,
      onlyFavoriteIds: to.meta.onlyFavoriteIds,
      onlyKnownChords: to.meta.onlyKnownChords
    };
    if ("search" in to.query) {
      obj.searchQuery = to.query.search;
    }
    this.$route.query.key = "what";
    store.dispatch("updateSongQueryAndLoad", obj);
    next();
  },

  computed: {
    page() {
      return this.$route.params.page;
    }
  },
  watch: {
    page(value) {
      console.log("page changed", value);
    }
  },
  mounted() {
    console.log("PlayAlongs mounted");
  },
  activated() {
    console.log("PlayAlongs activated");
    console.log(this.$route.params.page);
    console.log(this.$route.params.mode);
  },
  methods: {}
};
</script>

<style lang="css" scoped></style>
